import React, { useEffect, useState } from 'react';
import '../../styles/common/footer.scss';
import { doFetch } from '../../hooks/useApi';

function Footer() {
  const [options, setOptions] = useState<any>();
  useEffect(() => {
    (async ()=>{
      const option: any = await doFetch('/acf/v3/options/options/');
      setOptions(option.acf);
    })();
  }, []);

  return (
    <section className="footer">
      <div className="over-review">
        <div className="d-flex space-between r">
          <div className="info">
            <ul>
              <li dangerouslySetInnerHTML={{__html:options?.address_ja}}/>
              <li dangerouslySetInnerHTML={{__html:options?.address_en}}/>
              <br className="sp_only" />
              <li>設立: 2004.5.6 / 従業員数: {options?.pr_persons}名</li>
              <li>Tel: 03-5572-6070</li>
            </ul>
            <p className="privacy">
              <a href="https://vectorinc.co.jp/privacy" rel="noreferrer" target="_blank">Privacy policy</a>
            </p>
            <div className="links">
              <p>
                <a href="mailto:platinum_pr@vectorinc.co.jp" rel="noreferrer" target="_blank">
                  Contact<span>/</span>
                </a>
              </p>
              <p>
                <a href="https://twitter.com/Platinum_vector" rel="noreferrer" target="_blank">
                  Twitter<span>/</span>
                </a>
              </p>
              <p>
                <a href="https://www.facebook.com/platinuminc.pr" target="_blank">
                  Facebook<span>/</span>
                </a>
              </p>
              <p>
                <a
                  href="https://note.com/platinum_career/"
                  rel="noreferrer"
                  target="_blank"
                >
                  Careers
                </a>
              </p>
            </div>
          </div>
          <div className="footer-logo">
            <div>
              <img src={`${IMAGE_PATH}images/footer-logo.png`} alt="" />
              <span>©Platinum inc.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
